function onRecaptchaSuccess() {
  const recaptchaErrors = document.querySelectorAll('.form__errors');
  recaptchaErrors.forEach((error) => {
    error.style.display = 'none';
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const recaptchaInput = document.querySelector('[name="g-recaptcha-response"]');

  if (recaptchaInput) {
    recaptchaInput.addEventListener('change', function () {
      if (recaptchaInput.value) {
        const recaptchaErrors = document.querySelectorAll('.form__errors');
        recaptchaErrors.forEach((error) => {
          error.style.display = 'none';
        });
      }
    });
  }
});
